import { useMemo, useState } from 'react'
import { useRecordContext } from 'react-admin'
import { Switch, FormControlLabel } from '@mui/material'
import debounce from 'lodash/debounce'

import useUpdateDataProvider from '../hooks/useUpdateDataProvider'

const IsFreeField = props => {
  const { resource } = props
  const record = useRecordContext()
  const updateDataProvider = useUpdateDataProvider()
  const [isFree, setIsFree] = useState(record.isFree)

  const onChange = useMemo(() => {
    return debounce(
      isFree =>
        updateDataProvider(
          resource,
          { id: record.id, data: { isFree } },
          {
            onSuccess: {
              notification: { body: 'Update successfully', level: 'info' },
              redirectTo: `/${resource}`,
            },
            onFailure: {
              notification: {
                body: `Error: ${resource} not updated`,
                level: 'warning',
              },
            },
          },
        ),
      500,
    )
  }, [record.id, resource, updateDataProvider])

  const handleChange = async () => {
    setIsFree(prev => {
      onChange(!prev)
      return !prev
    })
  }

  return (
    <FormControlLabel
      control={<Switch checked={isFree} onChange={handleChange} />}
    />
  )
}

export default IsFreeField
